import MainFrame from "../../components/mainFrame";
import { Box, Button, IconButton, TableRow } from "@mui/material";
import styled from "@emotion/styled";
import StickyTable from "../../components/table";
import Navbar from "../../components/navbar";
import { Cell } from "../../components/table/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { useModal } from "../../components/modal";
import { DeleteModal } from "../../components/appbar/modal";
import { smallButton } from "../../components/Button";
import AddModal from "./modal";
import { Helmet } from "react-helmet";
import {
  useDeleteBannerMutation,
  useGetBannersQuery,
} from "../../app/services/banners.api";
import getImageLink from "../../utils/getImageLink";
import { useState } from "react";

const Container = styled(Box)({
  padding: "1rem",
  width: "100%",
  height: "100%",
  minHeight: "90vh",
  maxHeight: "90vh",
});

function Banners() {
  const { setShow, setContent } = useModal();
  const [query, setQuery] = useState<{
    page?: number;
    size?: number;
    title?: string;
  }>({
    page: 0,
    size: 10,
  });
  const { data, isLoading, isFetching } = useGetBannersQuery(query);
  const [deleteBanner] = useDeleteBannerMutation();
  function handleOpenModal(type: string, id?: string) {
    if (type === "edit" && id) {
      setContent({
        title: " ویرایش بنر",
        body: <AddModal defaultValue={data?.banners?.entities[id]} />,
      });
    }
    if (type === "add") {
      setContent({
        title: " افزودن بنر",
        body: <AddModal />,
      });
    }
    if (type === "delete" && id) {
      setContent({
        title: "حذف بنر",
        body: (
          <DeleteModal
            handleDelete={() =>
              deleteBanner({ bannerId: id })
                .unwrap()
                .then(() => {
                  setShow(false);
                })
                .catch((err) => {})
            }
          />
        ),
      });
    }
    setShow(true);
  }

  return (
    <Container bgcolor="primary.light">
      <Helmet>
        <title> بنرها | پنل ادمین yaadin</title>
      </Helmet>
      <Navbar title="بنرها">
        <Button
          onClick={() => handleOpenModal("add")}
          sx={[
            smallButton,
            {
              color: "divider",
              borderColor: "divider",
              borderStyle: "solid",
              borderWidth: "1px",
            },
          ]}
        >
          <AddIcon />
          افزودن بنر
        </Button>
      </Navbar>
      <StickyTable
        headers={[
          { name: "تصویر" },
          { name: "تصویر موبایل" },
          { name: "عنوان" },
          { name: "لینک" },
          { name: "صفحه بنر" },
        ]}
        length={data?.length ?? 0}
        isLoading={isLoading || isFetching}
        operations={true}
        onPageQueryChange={(q) => setQuery((prev) => ({ ...prev, ...q }))}
      >
        {data?.banners?.ids.map((id, indx) => {
          const banner = data?.banners.entities[id];
          return (
            <TableRow hover role="checkbox" tabIndex={-1} key={id}>
              <Cell
                sx={{
                  "&.MuiTableCell-root": {
                    color: "divider",
                    fontSize: ".8rem",
                  },
                }}
              >
                {indx + 1}
              </Cell>
              <Cell>
                <img
                  width={"10%"}
                  height={"10%"}
                  alt="desktop-image"
                  src={getImageLink(banner.desktop)}
                />
              </Cell>
              <Cell>
                <img
                  width={"10%"}
                  height={"10%"}
                  alt="mobile-image"
                  src={getImageLink(banner.mobile)}
                />
              </Cell>
              <Cell>{banner.title}</Cell>
              <Cell>{banner.link}</Cell>
              <Cell>{banner.location}</Cell>
              <Cell
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton onClick={() => handleOpenModal("edit", id)}>
                  <EditIcon sx={{ color: "divider" }} />
                </IconButton>
                <IconButton onClick={() => handleOpenModal("delete", id)}>
                  <DeleteIcon sx={{ color: "divider" }} />
                </IconButton>
              </Cell>
            </TableRow>
          );
        })}
      </StickyTable>
    </Container>
  );
}

export default MainFrame(Banners);
